import React, { useState, useEffect } from "react";
import "../App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import Services from './Services'
//import swal from 'sweetalert';
import * as AiIcons from 'react-icons/ai';
import { confirmAlert } from 'react-confirm-alert';
import { Table } from "react-bootstrap";
import Pagination from "rc-pagination";
import "./pagination.css";
import Form from 'react-bootstrap/Form'
import { hospitalcodedata } from './hospitalcodedata';
import { RotatingLines } from "react-loader-spinner";

const TagsData = () => {

  const [loading, setLoading] = useState(false);

  const [mother_tagIds, setmother_tagIds] = useState([]);
  const [filtered_MotherTag_Data, setFiltered_MotherTag_Data] = useState(mother_tagIds);


  const [child_tagIds, setchild_tagIds] = useState([]);
  const [filtered_ChildTag_Data, setFiltered_ChildTag_Data] = useState(child_tagIds);


  const [filterdata, setFilterdata] = useState({
    hospital_type: "",
    hospital_code: ""
  });

  const [hospitalfiltertype, sethospitalfiltertype] = useState([]);
  const [hospitalfiltercode, sethospitalfiltercode] = useState([]);

  useEffect(() => {
    try {
      const hospitaltype = [{ hospitaltype_name: "DME" }, { hospitaltype_name: "VVP" }];
      sethospitalfiltertype(hospitaltype);

      const filtered = hospitalcodedata.filter(hospitalcodedata => {
        return hospitalcodedata.hospitaltype_name === filterdata.hospital_type;
      });

      sethospitalfiltercode(filtered);
    } catch (e) {
      console.log(e);
    }
  }, [filterdata.hospital_type]);


  function handleChangeHospitaltypes(event, frm) {
    if (frm === "hspttype") {
      filterdata.hospital_code = "";
    }
    const { name, value } = event.target;
    setFilterdata({ ...filterdata, [name]: value });
  }


  const getData = () => {
    c_setCurrent(1);
    m_setCurrent(1);

    if (validateviewForm()) {
      setLoading(true);

      const formData = new FormData()
      formData.append('hospital_type', filterdata.hospital_type);
      formData.append('hospital_code', filterdata.hospital_code);

      Services.getMotherTagsdataByHospitalwise(formData).then((res) => {
        if (res.status === 200) {
          if (res.data.status === true) {
            const mothertagsdata = res.data.mothertagsdata;
            mothertagsdata.sort((firstItem, secondItem) => firstItem.mothertag_id - secondItem.mothertag_id);

            setmother_tagIds(mothertagsdata);
            setFiltered_MotherTag_Data(mothertagsdata);

          } else if (res.data.status === false) {
            alert("Empty Data");
            setmother_tagIds([]);
            setFiltered_MotherTag_Data([]);
          }
          setLoading(false);

        } else Promise.reject();
      }).catch((error) => {
        setmother_tagIds([]);
        setFiltered_MotherTag_Data([]);
        alert("Something went wrong(" + error + ")");
        setLoading(false);

      });


      Services.getChildTagsdataByHospitalwise(formData).then((res) => {
        if (res.status === 200) {
          if (res.data.status === true) {
            const childtagsdata = res.data.childtagsdata;
            childtagsdata.sort((firstItem, secondItem) => firstItem.childtag_id - secondItem.childtag_id);

            setchild_tagIds(childtagsdata);
            setFiltered_ChildTag_Data(childtagsdata);

          } else if (res.data.status === false) {
            alert("Empty Data");
            setchild_tagIds([]);
            setFiltered_ChildTag_Data([]);
          }
        } else Promise.reject();
      }).catch((error) => {
        setchild_tagIds([]);
        setFiltered_ChildTag_Data([]);
        alert("Something went wrong(" + error + ")");
      });

    }
  }


  const handleMothertagSearchhospital = (event) => {
    let firstLetter = event.target.value.charAt(0);
    event.target.value = firstLetter.toUpperCase() + event.target.value.slice(1);

    let value = event.target.value.toUpperCase();
    let result = [];
    console.log(value);
    result = mother_tagIds.filter((data) => {
      return data.hospital_type.toUpperCase().search(value) !== -1
        || data.hospital_code.toUpperCase().search(value) !== -1;
    });
    setFiltered_MotherTag_Data(result);
  }

  const handleMotherTagsdataSearch = (event, from) => {

    let firstLetter = event.target.value.charAt(0);
    event.target.value = firstLetter.toUpperCase() + event.target.value.slice(1);

    let value = event.target.value.toUpperCase();
    let result = [];
    result = mother_tagIds.filter((data) => {
      let fildata = "";


      if (from === "tagid") {
        fildata = data.mothertag_id;
      } else if (from === "status") {
        fildata = data.mothertag_status;
      }else if (from === "TagType") {
        fildata = data.mother_tag_entry_type;
      }
      return fildata.toUpperCase().search(value) !== -1;
    });
    setFiltered_MotherTag_Data(result);
  }


  const handleChildTagSearchhospital = (event) => {
    let firstLetter = event.target.value.charAt(0);
    event.target.value = firstLetter.toUpperCase() + event.target.value.slice(1);

    let value = event.target.value.toUpperCase();
    let result = [];
    console.log(value);
    result = child_tagIds.filter((data) => {
      return data.hospital_type.toUpperCase().search(value) !== -1
        || data.hospital_code.toUpperCase().search(value) !== -1;
    });
    setFiltered_ChildTag_Data(result);
  }

  const handleChildTagsdataSearch = (event, from) => {

    let firstLetter = event.target.value.charAt(0);
    event.target.value = firstLetter.toUpperCase() + event.target.value.slice(1);

    let value = event.target.value.toUpperCase();
    let result = [];
    result = child_tagIds.filter((data) => {
      let fildata = "";
      if (from === "tagid") {
        fildata = data.childtag_id;
      } else if (from === "status") {
        fildata = data.childtag_status;
      }else if (from === "TagType") {
        fildata = data.child_tag_entry_type;
      }
      return fildata.toUpperCase().search(value) !== -1;
    });
    setFiltered_ChildTag_Data(result);
  }







  const validateviewForm = (e) => {

    let formIsValid = true;

    if (!filterdata.hospital_type?.trim()) {
      alert("Select Hospital Type");
      formIsValid = false;
    } else if (!filterdata.hospital_code?.trim()) {
      alert("Select Hospital Code");
      formIsValid = false;
    }

    return formIsValid;
  }


  const [m_perPage] = useState(15);
  const [m_size, m_setSize] = useState(m_perPage);
  const [m_current, m_setCurrent] = useState(1);

  const m_PerPageChange = (value) => {
    m_setSize(value);
    const newPerPage = Math.ceil(filtered_MotherTag_Data.length / value);
    if (m_current > newPerPage) {
      m_setCurrent(newPerPage);
    }
  }

  const m_currentData = (m_current, pageSize) => {
    // Normally you should get the data from the server
    return filtered_MotherTag_Data.slice((m_current - 1) * pageSize, m_current * pageSize);
  };

  const m_PaginationChange = (page, pageSize) => {
    m_setCurrent(page);
    m_setSize(pageSize)
  }

  const m_PrevNextArrow = (m_current, type, originalElement) => {
    if (type === 'prev') {
      return <button><i className="fa fa-angle-double-left"></i></button>;
    }
    if (type === 'next') {
      return <button><i className="fa fa-angle-double-right"></i></button>;
    }
    return originalElement;
  }



  const deleteMothertagid = (id, name) => {
    confirmAlert({
      title: 'Confirm to Delete',
      message: 'Are you sure you want to delete this Mother Tag id == >  ' + name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            const formData = new FormData()
            formData.append('hospital_type', filterdata.hospital_type);
            formData.append('hospital_code', filterdata.hospital_code);
            formData.append('_id', id);

            Services.deleteMotherTagsdataByHospitalwise(formData).then((res) => {

              if (res.status === 200) {
                if (res.data.status === true) {
                  alert("Mother Tag successfully deleted");
                  const mother_tagIdsfilter = mother_tagIds.filter(mothertagIds => mothertagIds._id !== id);
                  setmother_tagIds(mother_tagIdsfilter);
                  setFiltered_MotherTag_Data(mother_tagIdsfilter);
                } else if (res.data.status === false) {
                  alert("Something went wrong")
                }
              } else Promise.reject();

            }).catch((err) => {
              alert("Something went wrong(" + err + ")")
            });
          }
        },
        {
          label: 'No',
          onClick: () => {
          }
        }
      ]
    });
  }





  const deleteChildtag = (id, name) => {
    confirmAlert({
      title: 'Confirm to Delete',
      message: 'Are you sure you want to delete this Child tag Id == >  ' + name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {

            const formData = new FormData()
            formData.append('hospital_type', filterdata.hospital_type);
            formData.append('hospital_code', filterdata.hospital_code);
            formData.append('_id', id);

            Services.deleteChildTagsdataByHospitalwise(formData).then((res) => {

              if (res.status === 200) {
                if (res.data.status === true) {
                  alert("Master successfully deleted");
                  const child_tagIdsfilter = child_tagIds.filter(childtagIds => childtagIds._id !== id);
                  setchild_tagIds(child_tagIdsfilter);
                  setFiltered_ChildTag_Data(child_tagIdsfilter);
                } else if (res.data.status === false) {
                  alert("Something went wrong")
                }
              } else Promise.reject();

            }).catch((err) => {
              alert("Something went wrong(" + err + ")")
            });


          }
        },
        {
          label: 'No',
          onClick: () => {
          }
        }
      ]
    });
  }






  const [c_perPage] = useState(15);
  const [c_size, c_setSize] = useState(c_perPage);
  const [c_current, c_setCurrent] = useState(1);

  const c_PerPageChange = (value) => {
    c_setSize(value);
    const newPerPage = Math.ceil(filtered_ChildTag_Data.length / value);
    if (c_current > newPerPage) {
      c_setCurrent(newPerPage);
    }
  }

  const c_currentData = (c_current, pageSize) => {
    // Normally you should get the data from the server
    return filtered_ChildTag_Data.slice((c_current - 1) * pageSize, c_current * pageSize);
  };

  const c_PaginationChange = (page, pageSize) => {
    c_setCurrent(page);
    c_setSize(pageSize)
  }

  const c_PrevNextArrow = (c_current, type, originalElement) => {
    if (type === 'prev') {
      return <button><i className="fa fa-angle-double-left"></i></button>;
    }
    if (type === 'next') {
      return <button><i className="fa fa-angle-double-right"></i></button>;
    }
    return originalElement;
  }



  // Return Agent form
  return (
    <div className="full_frame_center" >
      <div className="start_start" style={{
        background: "white", marginLeft: "1%", marginRight: "1%",
        marginTop: "10px", marginBottom: "50px", padding: "2%"
      }}>
        <div style={{ width: "100%" }}>
          <div className="start_start" style={{ width: "100%" }}>
            <h1 style={{ marginLeft: "10px", fontSize: "25px", fontWeight: "bold", color: "black" }}>Tags Information</h1>
          </div>

          <div style={{ borderTop: "1px solid #000 ", marginBottom: "10px" }}></div>

          <div className="start_start" style={{ width: "100%", marginLeft: "2%", marginTop: "2%" }}>

            <div className="start_center" style={{ width: "50%", flexDirection: "row" }}>
              <div className="start_start" style={{ width: "100%", flexDirection: "row" }}>

                <div className="start_start" style={{ width: "100%", flexDirection: "column", marginBottom: "20px" }}>
                  <label htmlFor="masterName" className='text-controol' style={{ color: "#190262", fontSize: "12px", fontWeight: "bold" }}>
                    Hospital Type<b style={{ color: "red" }}>*</b></label>
                  <Form.Select aria-label="Default select example" name="hospital_type" value={filterdata.hospital_type}
                    onChange={(event) => handleChangeHospitaltypes(event, "hspttype")} style={{ fontSize: "12px", fontWeight: "bold", width: "70%" }} >
                    <option value="">SELECT</option>
                    {hospitalfiltertype.map((hospitalfiltertype, index) => (
                      <option key={index} value={hospitalfiltertype.hospitaltype_name}>{hospitalfiltertype.hospitaltype_name}</option>
                    ))}
                  </Form.Select>
                </div>

                <div className="start_start" style={{ width: "100%", flexDirection: "column", marginBottom: "20px" }}>
                  <label htmlFor="masterName" className='text-controol' style={{ color: "#190262", fontSize: "12px", fontWeight: "bold" }}>
                    Hospital Code<b style={{ color: "red" }}>*</b></label>
                  <Form.Select aria-label="Default select example" name="hospital_code" value={filterdata.hospital_code}
                    onChange={(event) => handleChangeHospitaltypes(event, "")} style={{ fontSize: "12px", fontWeight: "bold", width: "70%" }} >
                    <option value="">SELECT</option>
                    {hospitalfiltercode.map((hospitalfiltercode, index) => (
                      <option key={index} value={hospitalfiltercode.hospitalcode_name}>{hospitalfiltercode.hospitalcode_name}</option>
                    ))}
                  </Form.Select>
                </div>

                <div className="start_start" style={{ width: "100%", flexDirection: "column", marginBottom: "20px" }}>
                  <label htmlFor="masterName" className='text-controol' style={{ color: "#190262", fontSize: "12px", fontWeight: "bold" }}>
                    Get</label>
                  <button className="btn btn-primary" style={{
                    background: "#190262", borderColor: "#190262", color: "#ffffff",
                    fontSize: "12px"
                  }} onClick={getData} >GET</button>
                </div>

              </div>

            </div>
          </div>

          {loading ? (

            <div className="center_center" style={{ width: "100%", display: "flex" }}>
              <RotatingLines width="50px" height="50px" strokeColor="red" strokeWidth="8"
                animationDuration="0.75" visible={true} />
            </div>

          ) : (

            <div className="start_start" style={{ width: "100%", flexDirection: "" }}>

              <div className="start_start" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                <div className="start_start" style={{ width: "100%" }}>
                  <h1 style={{ marginLeft: "10px", fontSize: "25px", fontWeight: "bold", color: "black" }}>Mother Tags</h1>
                </div>

                <Table striped bordered hover style={{ fontSize: "12px" }}>
                  <thead style={{ background: "lightsteelblue", color: "black" }}>
                    <tr>
                      <th style={{ background: "lightsteelblue", color: "black" }}>S.no</th>
                      <th style={{ background: "lightsteelblue", color: "black" }}>Hospital</th>
                      <th style={{ background: "lightsteelblue", color: "black" }}>Tag Type</th>
                      <th style={{ background: "lightsteelblue", color: "black" }}>Mother tag Id</th>
                      <th style={{ background: "lightsteelblue", color: "black" }}>Id status</th>
                      <th style={{ background: "lightsteelblue", color: "black" }}>Created Date</th>
                      {/* <th style={{ background: "lightsteelblue", color: "black" }} >Action</th> */}
                    </tr>
                  </thead>
                  <thead >
                    <tr>
                      <th></th>
                      <th>
                        <input type="text" className="form-control" placeholder="Hospital"
                          style={{ fontSize: "12px" }} onChange={(event) => handleMothertagSearchhospital(event, "Hospital")} />
                      </th>
                      <th>
                        <input type="text" className="form-control" placeholder="Tag Type"
                          style={{ fontSize: "12px" }} onChange={(event) => handleMotherTagsdataSearch(event, "TagType")} />
                      </th>
                      <th>
                        <input type="text" className="form-control" placeholder="Tag id"
                          style={{ fontSize: "12px" }} onChange={(event) => handleMotherTagsdataSearch(event, "tagid")} />
                      </th>
                      <th>
                        <input type="text" className="form-control" placeholder="Status"
                          style={{ fontSize: "12px" }} onChange={(event) => handleMotherTagsdataSearch(event, "status")} />
                      </th>
                      <th></th>
                      {/* <th></th> */}
                    </tr>
                  </thead>
                  <tbody >
                    {m_currentData(m_current, m_size).map((mothertagdata, index) => (

                      <tr key={index}>
                        <td>{(m_current - 1) * m_perPage + index + 1}</td>
                        <th>{mothertagdata.hospital_type}({mothertagdata.hospital_code})</th>
                        <th>{mothertagdata.mother_tag_entry_type}</th>
                        <td>{mothertagdata.mothertag_id}</td>
                        <td>
                          {(() => {
                            if (mothertagdata.mothertag_status === "Added") {
                              return (
                                <b style={{ color: "black" }}>{mothertagdata.mothertag_status} </b>
                              )
                            } else if (mothertagdata.mothertag_status === "Available") {
                              return (
                                <b style={{ color: "green" }}>{mothertagdata.mothertag_status} </b>
                              )
                            } else if (mothertagdata.mothertag_status === "Used") {
                              return (
                                <b style={{ color: "orange" }}>{mothertagdata.mothertag_status} </b>
                              )
                            } else if (mothertagdata.mothertag_status === "Damaged") {
                              return (
                                <b style={{ color: "red" }}>{mothertagdata.mothertag_status} </b>
                              )
                            } else {
                              return (
                                <b style={{ color: "black" }}>{mothertagdata.mothertag_status} </b>
                              )
                            }
                          })()}
                        </td>
                        <td>{mothertagdata.mothertag_created_date}</td>
                        {/* <td>
                        <AiIcons.AiOutlineDelete style={{ color: "red", height: "20px", width: "20px", cursor: "pointer" }}
                          onClick={(e) => deleteMothertagid(mothertagdata._id, mothertagdata.mothertag_id)} />
                      </td> */}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div >
                  <Pagination
                    className="pagination-data"
                    showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total}`}
                    onChange={m_PaginationChange}
                    total={filtered_MotherTag_Data.length}
                    current={m_current}
                    pageSize={m_size}
                    showSizeChanger={false}
                    showTitle={false}
                    itemRender={m_PrevNextArrow}
                    onShowSizeChange={m_PerPageChange} />
                </div>
              </div>

              <div className="start_start" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>

                <div className="start_start" style={{ width: "100%" }}>
                  <h1 style={{ marginLeft: "10px", fontSize: "25px", fontWeight: "bold", color: "black" }}>Child Tags</h1>
                </div>
                <Table striped bordered hover style={{ fontSize: "12px" }}>
                  <thead style={{ background: "lightsteelblue", color: "black" }}>
                    <tr>
                      <th style={{ background: "lightsteelblue", color: "black" }}>S.no</th>
                      <th style={{ background: "lightsteelblue", color: "black" }}>Hospital</th>
                      <th style={{ background: "lightsteelblue", color: "black" }}>Tag Type</th>
                      <th style={{ background: "lightsteelblue", color: "black" }}>Child tag Id</th>
                      <th style={{ background: "lightsteelblue", color: "black" }}>Id status</th>
                      <th style={{ background: "lightsteelblue", color: "black" }}>Created Date</th>
                      {/* <th style={{ background: "lightsteelblue", color: "black" }} >Action</th> */}
                    </tr>
                  </thead>
                  <thead >
                    <tr>
                      <th></th>
                      <th>
                        <input type="text" className="form-control" placeholder="Hospital"
                          style={{ fontSize: "12px" }} onChange={(event) => handleChildTagSearchhospital(event, "Hospital")} />
                      </th>
                      <th>
                        <input type="text" className="form-control" placeholder="Tag Type"
                          style={{ fontSize: "12px" }} onChange={(event) => handleChildTagsdataSearch(event, "TagType")} />
                      </th>
                      <th>
                        <input type="text" className="form-control" placeholder="Tag id"
                          style={{ fontSize: "12px" }} onChange={(event) => handleChildTagsdataSearch(event, "tagid")} />
                      </th>
                      <th>
                        <input type="text" className="form-control" placeholder="Status"
                          style={{ fontSize: "12px" }} onChange={(event) => handleChildTagsdataSearch(event, "status")} />
                      </th>
                      <th></th>
                      {/* <th></th> */}
                    </tr>
                  </thead>
                  <tbody >
                    {c_currentData(c_current, c_size).map((childtagdata, index) => (

                      <tr key={index}>
                        <td>{(c_current - 1) * c_perPage + index + 1}</td>
                        <th>{childtagdata.hospital_type}({childtagdata.hospital_code})</th>
                        <th>{childtagdata.child_tag_entry_type}</th>
                        <td>{childtagdata.childtag_id}</td>
                        <td>
                          {(() => {
                            if (childtagdata.childtag_status === "Added") {
                              return (
                                <b style={{ color: "black" }}>{childtagdata.childtag_status} </b>
                              )
                            } else if (childtagdata.childtag_status === "Available") {
                              return (
                                <b style={{ color: "green" }}>{childtagdata.childtag_status} </b>
                              )
                            } else if (childtagdata.childtag_status === "Used") {
                              return (
                                <b style={{ color: "orange" }}>{childtagdata.childtag_status} </b>
                              )
                            } else if (childtagdata.childtag_status === "Damaged") {
                              return (
                                <b style={{ color: "red" }}>{childtagdata.childtag_status} </b>
                              )
                            } else {
                              return (
                                <b style={{ color: "black" }}>{childtagdata.childtag_status} </b>
                              )
                            }
                          })()}
                        </td>
                        <td>{childtagdata.childtag_created_date}</td>
                        {/* <td>
                        <AiIcons.AiOutlineDelete style={{ color: "red", height: "20px", width: "20px", cursor: "pointer" }}
                          onClick={(e) => deleteChildtag(childtagdata._id, childtagdata.childtag_id)} />
                      </td> */}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div >
                  <Pagination
                    className="pagination-data"
                    showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total}`}
                    onChange={c_PaginationChange}
                    total={filtered_ChildTag_Data.length}
                    current={c_current}
                    pageSize={c_size}
                    showSizeChanger={false}
                    showTitle={false}
                    itemRender={c_PrevNextArrow}
                    onShowSizeChange={c_PerPageChange} />
                </div>
              </div>

            </div>

          )}

        </div>
      </div>
    </div>
  );
};

// Export TagsData Component
export default TagsData;